import { render } from "./DropdownType.vue?vue&type=template&id=4bc08488"
import script from "./DropdownType.vue?vue&type=script&lang=js"
export * from "./DropdownType.vue?vue&type=script&lang=js"

import exportComponent from "/home/tadam/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__